export function generateNumberArray(max: number, step: number, start = 0): number[] {
  const arr = [];
  for (let i = start; i <= max; i += step) {
    arr.push(i);
  }
  return arr;
}

export function toClock(i: number) {
  return (i < 10 ? '0' : '') + i;
}

export const HOME_OFFICE_ABSENCE_NAME = 'Praca zdalna';
export const HOME_DUTY_ABSENCE_NAME = 'Dyżur domowy';
